import { ForgotPassword } from '@/components/auth'

export default function ForgotPasswordPage() {
  return <ForgotPassword />
}
